<div style="display: flex; flex-direction: column; height: 100%">
	<ng-content></ng-content>
</div>
